import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Typography, Input } from 'antd';
import {
    trainingProjectFormFields,
    trainingProjectTaskTypeValues,
    taskTypeFieldDescriptions
} from '../../misc/constants';
import { TrainingProjectTaskType } from '../../types';
import { TrainingProjectsStore } from '../../stores';

interface Props {
    store: TrainingProjectsStore;
}

const TrainingProjectFieldDescriptions: React.FC<Props> = ({ store }) => {
    return (
        <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => {
                const taskType = getFieldValue(trainingProjectFormFields.taskType) as
                    | TrainingProjectTaskType
                    | undefined;

                if (taskType === trainingProjectTaskTypeValues.JsonExtraction) {
                    return (
                        <>
                            <Typography.Title level={5}>Field Descriptions</Typography.Title>
                            <Form.Item
                                label="Input"
                                name={[
                                    trainingProjectFormFields.fieldDescriptions,
                                    taskTypeFieldDescriptions[taskType].input
                                ]}
                                initialValue={
                                    store.editableTrainingProject?.fieldDescriptions?.[
                                        taskTypeFieldDescriptions[taskType].input
                                    ]
                                }
                            >
                                <Input.TextArea placeholder="Enter input field description..." rows={4} />
                            </Form.Item>
                            <Form.Item
                                label="Output"
                                name={[
                                    trainingProjectFormFields.fieldDescriptions,
                                    taskTypeFieldDescriptions[taskType].output
                                ]}
                                initialValue={
                                    store.editableTrainingProject?.fieldDescriptions?.[
                                        taskTypeFieldDescriptions[taskType].output
                                    ]
                                }
                            >
                                <Input.TextArea placeholder="Enter output field description..." rows={4} />
                            </Form.Item>
                        </>
                    );
                }

                return null;
            }}
        </Form.Item>
    );
};

export default observer(TrainingProjectFieldDescriptions);
